export enum MusicPlayerEventConstants {
  ANGULAR_PLAYER_READY = 'angularPlayer:ready',
  // CURRENT_TRACK_DURATION = 'currentTrack:duration',
  // CURRENT_TRACK_POSITION = 'currentTrack:position',
  MUSIC_IS_PLAYING = 'music:isPlaying',
  MUSIC_MUTE = 'music:mute',
  MUSIC_REPEAT = 'music:repeat',
  MUSIC_VOLUME = 'music:volume',
  PLAYER_PLAYLIST = 'player:playlist',
  SOUND_MANAGER_READY = 'Sound manager ready!',
  TRACK_ID = 'track:id',
  TRACK_LOADED = 'track:loaded',
  TRACK_STOP = 'track:stop',
  // TRACK_PROGRESS = 'track:progress',
}
